import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import blueBackground from 'assets/images/pickapier/tem-poupup-blue-background.png';

export const ModalBody = styled.div`
  text-align: center;
`;

export const ImageWrapper = styled.div`
  margin-bottom: 17px;
  width: 190px;
  height: 124px;
  @media only screen and (max-width: 480px) {
    margin-bottom: 15px;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  &.blue {
    background-image: url(${blueBackground});
    padding: 41px 20px 33px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    &.is-mobile {
      padding: 10px 20px 12px;
    }
  }
  &.white {
    background-color: ${themeGet('color.1', '#ffffff')};
    padding: 30px 20px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    &.is-mobile {
      padding: 12px 20px;
    }
  }
  h2,
  h3 {
    font-weight: bold;
  }
  h2 {
    font-size: 25px;
    line-height: normal;
    margin-bottom: 19px;
    color: ${themeGet('color.1', '#ffffff')};
    @media only screen and (max-width: 480px) {
      font-size: 20px;
      line-height: 24px;
      margin-bottom: 10px;
    }
  }
  h3 {
    font-size: 20px;
    line-height: normal;
    margin-bottom: 20px;
    color: ${themeGet('text.4', '#323232')};
    @media only screen and (max-width: 480px) {
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 10px;
    }
  }
  p {
    color: ${themeGet('color.1', '#ffffff')};
    font-size: 14px;
    line-height: normal;
    margin-bottom: 0;
    a {
      font-weight: bold;
      text-decoration: underline;
      margin-left: 3px;
      color: ${themeGet('color.1', '#ffffff')};
    }
  }
  button {
    &.ant-btn-link {
      font-size: 14px;
      line-height: 1.71;
      height: 24px;
    }
  }
  .request-button {
    display: inline-block;
    height: 47px;
    font-size: 15px;
    font-weight: 700;
    padding: 0 20px;
    margin-bottom: 13px;
    line-height: 47px;
    border-radius: 4px;
    min-width: 162px;
    color: ${themeGet('color.1', '#ffffff')};
    border-color: ${themeGet('primary.0', '#194AB9')};
    background-color: ${themeGet('primary.0', '#194AB9')};
  }
`;
